import React from 'react';

import classNames from 'classnames';

import classes from './LbUnderlineTabsList.module.scss';
import { TabOption, TabsConfig, TabValue } from '../types/TabsConfig';
import { useTabsContext } from '../context/TabsContext';

export type LbUnderlineTabsListProps = {
  tabsConfig: TabOption[] | TabsConfig[];
  className?: string;
};

export const LbUnderlineTabsList = ({
  tabsConfig,
  className,
}: LbUnderlineTabsListProps) => {
  const { value, onValueChange } = useTabsContext();

  const listClasses = classNames(className, classes.container);

  const handleTabClick = (tabValue: TabValue) => {
    onValueChange(tabValue);
  };

  return (
    <div className={listClasses} role="tablist">
      {tabsConfig.map(
        (tab) =>
          !tab.hide && (
            <button
              type="button"
              role="tab"
              aria-selected={value === tab.value}
              aria-controls={`panel-${tab.value}`}
              id={`tab-${tab.value}`}
              className={classNames(classes.tab, {
                [classes.selected]: value === tab.value,
              })}
              disabled={tab.disabled}
              onClick={() => handleTabClick(tab.value)}
              key={tab.value}
            >
              {!!tab.icon && <span className={classes.icon}>{tab.icon}</span>}
              <span>{tab.label}</span>
            </button>
          ),
      )}
    </div>
  );
};
